
import { Vue, Component, Watch } from 'vue-property-decorator'
import {
	getFinanceAuthority,
	getFDwhiteAuthority,
	payStoreOrderWhite,
	payStoreOrderOffline,
	resetStoreOrderOffline,
	getInterestFree,
	getRegulations,
	getLoanTrial,
	getAvoidLoginUrl,
	getWhiteSign,
	getPartnerPayAcctList,
} from '@/api/iousServices'
import math from '@/core/math'
import { getStoreOrderDtl } from '@/api/industryMall'
import { Getter } from 'vuex-class'
import dayjs from 'dayjs'
import { openFDWhitePage, getSessionItem, setSessionItem, launchWeixinMiniProgram, launchAliMiniProgram, launchHuiFuProgram } from '@/utils/h5ToApp'
import { payStoreOrderAllin, getPayStatus, getPayAuthority, payStoreOrderHuifuAlipay, payStoreOrderHuifuWeChat, getPayStatusHuiFu } from '@/api/thirdPay'
import { Toast } from 'vant'
import whitePayPopup from './template/whitePayPopup.vue'
@Component({
	name: 'IOUsServices',
  components: {
    whitePayPopup
  },
	filters: {
		filterMethod: (type: string) => {
			const text = {
				'1': '30天内随还',
				'2': '分期随还',
				'3': '90天内随还',
				'4': '先息后本',
				'5': '等额本息',
				'6': '到期还本付息',
				'7': '随借随还',
				'8': '等本等息',
			}
			return text[type]
		},
	},
})
export default class IOUsServices extends Vue {
	@Getter companyId!: string // 公司编号
	@Getter partnerCompanyId!: string //合作方公司编号
	@Getter mobile!: string

  $refs: {
    whitePayPopup:whitePayPopup
  }

	isFreeTax = false //是否免息
	priceValue: any = ''
	totalMoney: any = '' //订单金额
	restMoney = '' //剩余金额
	whiteStrips = 1
	whiteStripsInfo = {
		creditAmount: 0, // 白条额度
		balance: 0, // 白条余额
		freezeDate: '',
    isAudit: 4 // 是否激活
	}
	loanInfo = {
		repayMethod: '', //0：按分期还款 1：按一次性还款
		principal: '',
		interestAll: '',
		periods: '',
	}
	orderId = ''
	endDate = ''
	startDate = dayjs().format('YYYY-MM-DD')
	content = ''
	showContent = false
	showTips = false
	whiteSignTime = ''
	endSignTime = ''
	isHidden = false

  // 是否有第三方支付的权限
  isAllinpay = null

	// 支付方式 Wechat为微信 Alipay为支付宝 默认白条支付whitePay  原始
	// payWay = 'whitePay'
	payWay = ''  // 白条快付模块隐藏，不设置默认支付方式
	// 通联小程序收银台原始 ID 重要
	userName = 'gh_e64a1a89a0ad'

	alternateMoney = '' // 候补金额

	async created() {
		// 清除回退地址，防止缓存导致跳转异常
		setSessionItem('cykjSource', '')
		// 通过页面visibilitychange事件，获取当前页面进入、离开状态
		window.addEventListener('visibilitychange', () => {
			this.isHidden = document.hidden
		})
    this.getAuthority()
		const { orderId, orderMoney } = this.$route.query
		if (window.localStorage.getItem('orderId') && !orderMoney) {
      this.orderId = window.localStorage.getItem('orderId')
			await this.getOrderDetail()
		} else {
      this.orderId = orderId as string
			// this.totalMoney = orderMoney as any;
			await this.getOrderDetail()
		}
		console.log('totalMoney', this.totalMoney)
    this.getPayAuthority()
		this.getFDwhiteInfo()
		this.getLoan()
		this.getFree()
		this.getSign()
		this.whiteStripsInfo.freezeDate = dayjs(this.whiteStripsInfo.freezeDate).format('YYYY-MM-DD')
		this.endDate = dayjs(this.whiteStripsInfo.freezeDate).add(60, 'day').format('YYYY-MM-DD')
		console.log('冻结日期+60天', this.endDate)
		console.log('冻结日期', this.whiteStripsInfo.freezeDate)
	}

	get opacityBtn() {
		return this.priceValue.length ? '' : 0.4
	}

  get safetyHeight () {
    return this.$store.state.app.safetyHeight
  }

	@Watch('isHidden')
	changeHidden(val: boolean) {
		if (this.payWay !== 'whitePay') {
			this.getPayStatus()
		}
		// 获取当前订单支付状态，支付成功（success），返回上一级页面
		getSessionItem('payStatus').then((res) => {
			console.log('payStatus--------------', res)
			if (res === 'success') {
				this.$router.back()
				setTimeout(() => {
					setSessionItem('payStatus', '')
				}, 500)
			}
		})
	}

  /**
   * 白条快付额度激活弹框
   */
  activeWhitePay() {
    this.$refs.whitePayPopup.showPopup()
  }

	/**
	 * 查询是否具有第三方支付权限
	 */
	getPayAuthority() {
		const params = {
			partnerCompanyId: this.partnerCompanyId,
		}
		getPayAuthority(params).then((res) => {
			console.log('res==', res)
      this.isAllinpay = res.data[0] ? res.data[0].isAllinpay : ''
		})
	}

	/**
	 * 选择第三方支付
	 */
	payClick(payWay: string) {
		if (this.payWay === payWay) {
			this.payWay = ''
			return
		}
		this.payWay = payWay
	}

	/**
	 * 调用第三方支付
	 */
	payStoreOrderAllin() {
		let data = {
			orderId: this.orderId,
			payWay: this.payWay,
			// 0正常支付，1候补支付
			type: this.$route.query.type,
			payMoney:this.$route.query.type==='0'?this.totalMoney:this.alternateMoney
		}
		payStoreOrderAllin(data).then((res) => {
			let data = res.data.data || {}
			let miniprogramPayInfo_VSP = data.miniprogramPayInfo_VSP || {}
			// 支付宝参数
			let thirdPartSchema = res.data.thirdPartSchema || ''
			// 支付宝参数
			let query = res.data.query || ''
			// 微信参数
			let weChatQuery = Object.keys(miniprogramPayInfo_VSP)
				.map((k) => `${k}=${miniprogramPayInfo_VSP[k]}`)
				.join('&')
			console.log('weChatQuery====', weChatQuery)

			let path = `pages/orderDetail/orderDetail?${weChatQuery}`

			if (this.payWay === 'Wechat') {
				launchWeixinMiniProgram({ userName: this.userName, path }).then((type) => {
					this.openPoll(type)
				})
			}

			if (this.payWay === 'Alipay') {
				const aliPath = 'alipays://platformapi/startapp?appId=2021001104615521&page=pages/orderDetail/orderDetail&thirdPartSchema='
				launchAliMiniProgram(`${aliPath}${encodeURIComponent('allinpaysdk://sdk/')}&query=${query}`).then((type) => {
					this.openPoll(type)
				})
			}
		})
	}

	// 切换汇付天下需求调用
  payStoreOrderHF () {
    let data = {
      orderId: this.orderId,
      payWay: this.payWay,
      // 0正常支付，1候补支付
      type: this.$route.query.type,
      payMoney:this.$route.query.type==='0'?this.totalMoney:this.alternateMoney,
      preOrderType: this.payWay === 'Wechat' ? '3' : '2'
    }
    // preOrderType string  2：支付宝3：微信
    payStoreOrderHuifuWeChat(data).then(res => {
      let url = ''
      if (this.payWay === 'Wechat') url = `${res.data.data.miniapp_data.path}?p=${res.data.data.pre_order_id}&s=app`
      if (this.payWay === 'Alipay') url = res.data.data.jump_url
      // console.log('pay url ***', url, res.data.data.miniapp_data.gh_id)
      if (this.payWay === 'Wechat') {
        launchWeixinMiniProgram({ userName: res.data.data.miniapp_data.gh_id, path: url }).then((type) => {
          this.openPoll(type)
        })
      } else {
        launchAliMiniProgram(url).then((type) => {
          this.openPoll(type)
        })
      }
    })
  }

	/**
	 * 开启轮询
	 */
	openPoll(type) {
		if (type === '0') {
			this.$toast('支付失败')
			return false
		}
	}

	/**
	 * 主动获取支付结果(getPayStatus)
	 * @param orderId
	 */
	getPayStatus() {
		let params = {
			orderId: this.orderId,
			// 0正常支付，1候补支付
			type: this.$route.query.type
		}
    getPayStatusHuiFu(params).then((res) => {
			let payStatus = Number(res.data.payStatus)
			// @ts-ignore
			let alternateStatus = Number(res.data.alternateStatus)
			if (payStatus===2 && this.$route.query.type==='0') {
				this.$dialog.alert({
					message: '支付成功',
				}).then(() => {
					this.goShop()
				})
			}else if (payStatus===2 && this.$route.query.type==='1' && alternateStatus === 1 ) {
				this.$dialog.alert({
					message: '支付成功',
				}).then(() => {
					this.goShop()
				})
			} else if (payStatus === -1) {
				this.$dialog.alert({
					message: '支付失败，请重新支付',
				}).then(() => {})
			}
			// switch (payStatus) {
			// 	case 2:
			// 		this.$dialog
			// 			.alert({
			// 				message: '支付成功',
			// 			})
			// 			.then(() => {
			// 				this.goShop()
			// 			})
			// 		break
			// 	case -1:
					// this.$dialog
					// 	.alert({
					// 		message: '支付失败，请重新支付',
					// 	})
					// 	.then(() => {})
			// 		break
			// 	default:
			// 		break
			// }
		})
	}

	async getOrderDetail() {
		await getStoreOrderDtl({ orderId: this.orderId })
			.then((res) => {
				const { data } = res
				this.totalMoney = data[0].playMoney ? Number(math.mathSubtract(data[0].orderMoney, data[0].playMoney)) : data[0].orderMoney
				this.alternateMoney = data[0].alternateMoney
				// this.storeId = data[0].storeId
        if(data[0].payStatus === 3 && data[0].payWay === 1) {
          const toast = Toast.loading({
            position:'top',
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: '订单正在支付\n请勿重新支付',
          });
          setTimeout(() => {
            toast.clear()
            this.goShop()
          }, 2000);
        }
			})
			.catch((err) => {
				console.log(err)
			})
	}

	/**
	 * 获取白条权限
	 */
	getAuthority() {
		getFinanceAuthority().then((res) => {
			const { code, data } = res
			if (code === '000000') {
				this.whiteStrips = data.whiteStrips
			}
			console.log('getAuthority=', res)
		})
	}

	/**
	 * 获取白条快付信息
	 */
	getFDwhiteInfo() {
		getFDwhiteAuthority().then((res) => {
			const { code, data } = res
			if (code === '000000') {
				this.whiteStripsInfo = data[0] || []
        // this.whiteStripsInfo.isAudit = 0
			}
			console.log('getFDwhiteInfo=', res)
		})
	}

	/**
	 * 获取白条快付分期方案
	 */
	getLoan() {
		let params = {
			partnerCompanyId: this.partnerCompanyId,
			amount: this.$route.query.type==='0'?this.totalMoney: this.alternateMoney,
		}
		getLoanTrial({ ...params }).then((res) => {
			const { code, data } = res
			if (code === '000000') {
				this.loanInfo = data
			}
			console.log('getLoanTrial=', res)
		})
	}

	/**
	 * 是否有免息权限
	 */
	getFree() {
		getInterestFree({ partnerCompanyId: this.partnerCompanyId }).then((res) => {
			const { code, data } = res
			if (code === '000000') {
				this.isFreeTax = data[0].interestFree === 1 ? true : false
				if (data[0].showInterestFree) {
					// 免息声明
					// this.getFreeRegulations()
				}
				// 0：不免,1:免息
				// if (this.isFreeTax) {
				//     this.getFreeRegulations();
				// }
			}
			console.log('getInterestFree=', res)
		})
	}

	/**
	 * 免息权限说明
	 */
	getFreeRegulations() {
		getRegulations({ partnerCompanyId: this.partnerCompanyId }).then((res) => {
			const { code, data } = res
			if (code === '000000') {
				this.content = data[0].content
				this.showContent = true
			}
			console.log('getInterestFree=', res)
		})
	}

	/**
	 * 线下支付
	 */
	offlinePay() {
		// if( this.priceValue < 1 ) {
		//     this.$toast('金额不能小于1元')
		//     return
		// }
		// if (this.priceValue > this.totalMoney * 1) {
		// 	this.$toast('金额不能大于待付款金额')
		// 	return
		// }
		let params = {
			orderId: this.orderId,
			// payMoney: this.priceValue,
			payMoney: this.$route.query.type==='0'?this.totalMoney: this.alternateMoney,
			// 0正常支付，1候补支付
			type: this.$route.query.type
		}
		payStoreOrderOffline({ ...params }).then((res) => {
			const { code, data } = res
			if (code === '000000') {
				// this.totalMoney = data.orderMoney
				this.totalMoney = data.orderMoney
				if (!Number(this.totalMoney)) {
					this.$router.push({
						path: '/orderMall',
						query: {
							orderType: '',
							orderName: '全部订单',
							form: 'orderMall'
						},
					})
				} else {
					console.log('线下支付成功', res)
					this.getLoan()
				}
			}
		})
	}

	/**
	 * 重置线下支付
	 */
	resetOfflinePay() {
		resetStoreOrderOffline({ orderId: this.orderId }).then((res) => {
			const { code, data } = res
			if (code === '000000') {
				this.totalMoney = data.orderMoney
				this.priceValue = ''
				console.log('重置成功', res)
				this.getLoan()
			}
		})
	}
	/**
	 * 第三方支付
	 */
	thirdPay() {
		if (this.payWay !== 'offlinePay') {
			// this.payStoreOrderAllin()
      this.payStoreOrderHF()
		} else {
			this.offlinePay()
		}
	}

	/**
	 * 白条支付
	 */
	async goPay() {
		if (!this.payWay) {
			this.$toast('请选择支付方式！')
			return
		}
		// debugger
		// this.$refs.resultPopup.showModal()
		// 待付款金额为0时，点击立即支付操作？
		if (this.payWay !== 'whitePay') {
			this.thirdPay()
			return
		}
    // 校验b类客户没有通过审核之前无法进行白条支付
    if(this.whiteStrips === 1 && this.whiteStripsInfo.isAudit !== 1) {
      return
    }

		// 店铺暂无收款信息
		if ([1, 4].includes(Number(this.whiteStrips))) {
			const params = {
				partnerCompanyId: this.partnerCompanyId,
			}
			const data = await getPartnerPayAcctList(params)
			if (!data.data.length) {
				this.$toast('店铺暂无收款信息，请联系店铺！')
				return
			}
		}
		if (!this.totalMoney) {
			this.$router.go(-1)
		}
		// 未开通白条
		if (this.whiteStrips !== 1) {
			this.$toast('请开通白条支付')
			return
		}
		// 被冻结
		if (this.endDate !== 'Invalid Date' && this.endDate > this.startDate) {
			this.$toast(`请在${this.endDate}重试`)
			return
		}
		// 白条余额小于待付款金额
		if (this.whiteStripsInfo.balance < this.totalMoney * 1) {
			this.$toast('白条余额不足')
			return
		}
    // 产业数智通-调整申请白条快付限制金额需求-改成100
		if (this.totalMoney < 100) {
			this.$toast('白条快付金额需大于100元')
			return
		}
		payStoreOrderWhite({ orderId: this.orderId, payMoney:this.$route.query.type==='0'?this.totalMoney:this.alternateMoney }).then((res) => {
			const { code, data } = res
			if (code === '000000') {
				if (String(data.orderMoney).includes('.')) {
					this.$dialog
						.confirm({
							title: '提示',
							message: '白条快付仅支持整数申请\n已将金额自动抹零',
						})
						.then(() => {
							this.headlePayWhite(data)
						})
						.catch(() => {
							// on cancel
						})
				} else {
					this.headlePayWhite(data)
				}
			}else if(code === '000002') {
      // 当用户状态是已开通状态，还停留在界面，后台已经将客户设置成待激活/拒绝状态
      // 需要提示客户，并重新刷新接口
        this.$dialog.alert({
            title: '提示',
            message: res.msg,
        }).then(() => {
          this.getFDwhiteInfo()
        })
      }
			console.log('白条支付获取金额成功', res)
		}).catch((err) => {
    })
	}
	headlePayWhite(data: any) {
		if (window.localStorage.getItem('isSign') == '1' && this.whiteSignTime < this.endSignTime) {
			this.fdfreeLogin('3')
		} else {
			this.$router.push({
				path: '/iousAuthorize',
				query: {
					cykjSource: 'iousServices',
					orderId: data.cytOrderId,
					tradeMoney: String(data.orderMoney).split('.')[0],
					webshow: '3', // 支付传3
				},
			})
		}
	}
	goPurchase() {
		if (this.$route.query.fromPage === '认证通过') {
			// 从企业认证页面过来，回到全部订单页面
			this.$router.push({ path: '/orderMall', query: { orderName: '全部订单', from: 'authorizeConfirm' } })
		} else {
			this.$router.back()
		}
		// this.$router.push("/purchaseOrderList");
		// this.$router.push({ path: "/orderMall" , query: {orderName: "全部订单", from: 'cashier'}});
	}
	goRegister() {
		//判断whitestrips权限 1已开通 2未完成企业认证 3需个人认证 4未开通，但有开通权限 5没权限
		console.log('whiteStrips=', this.whiteStrips)
		switch (this.whiteStrips) {
			case 2:
				this.$dialog
					.confirm({
						message: '当前企业未完成企业认证，暂时无法使用支付功能',
						confirmButtonText: '去认证',
						cancelButtonText: '取消支付',
					})
					.then(() => {
						window.localStorage.setItem('FDWhite', '1')
						window.localStorage.removeItem('isFinance')
						this.$router.push({
							path: '/companyInfoForm',
							query: {
								formPage: 'h5',
							},
						})
					})
					.catch(() => {
						// this.$router.push("/purchaseOrderList");
					})
				break
			case 3:
				this.$dialog
					.confirm({
						message: '当前账号未完成身份认证，暂时无法使用支付功能',
						confirmButtonText: '去认证',
						cancelButtonText: '取消支付',
					})
					.then(() => {
						window.localStorage.setItem('FDWhite', '1')
						window.localStorage.removeItem('isFinance')
						this.$router.push({
							path: '/userInfoForm',
							query: {
								formPage: 'h5',
							},
						})
					})
					.catch(() => {
						// this.$router.push("/purchaseOrderList");
					})
				break
			case 4:
				// 是否签署授权书
				if (window.localStorage.getItem('isSign') == '1' && this.whiteSignTime < this.endSignTime) {
					this.fdfreeLogin('2')
				} else {
					window.localStorage.removeItem('isSign')
					this.$router.push({
						path: '/iousAuthorize',
						query: {
							webshow: '2',
							cykjSource: 'iousServices',
						},
					})
				}
				break
		}
	}
	onInput(e) {
		this.priceValue = e
	}
	// 1还款入口 2授信入口 3借款入口
	fdfreeLogin(flag = '') {
		let params: any = {
			companyId: this.companyId,
			webShow: flag,
		}
		let money
		if (flag === '3') {
			money = String(this.totalMoney).split('.')[0]
			params = {
				...params,
				orderId: this.orderId,
				tradeMoney: money,
			}
		}
		getAvoidLoginUrl({ ...params })
			.then((res) => {
				const { code, data } = res
				if (code === '000000') {
					let encodeUrl = encodeURI(data.responseData.redirectUrl)
					// 完成授信流程，webShow=1或3替换成2
					if (encodeUrl.indexOf('webShow=1') > -1 || encodeUrl.indexOf('webShow=2') > -1 || encodeUrl.indexOf('webShow=3') > -1) {
						encodeUrl.replace(/webShow=[d{1,3}]/, `webShow=${flag}`)
					}
					let isQuery = encodeUrl.indexOf('?') > -1
					let url = `${encodeUrl}${isQuery ? '&' : '?'}userPhone=${this.mobile}`
					if (flag === '3') {
						url += `&totalMoney=${String(money).split('.')[0]}&cykjOrderId=${this.orderId}`
					}
					// window.location.href = url
					openFDWhitePage({ url })
					console.log('getAvoidLoginUrl=', url)
				}
			})
			.catch(() => {
				this.$toast('此产业商城暂未开通白条快付')
			})
	}

	getSign() {
		// 获取授权书记录
		getWhiteSign().then((res) => {
			const { code, data } = res
			if (code === '000000' && data) {
				let firstSignTime = data.whiteSignTime
				firstSignTime = dayjs(firstSignTime).format('YYYY-MM-DD')
				this.endSignTime = dayjs(firstSignTime).add(360, 'day').format('YYYY-MM-DD')
				this.whiteSignTime = dayjs().format('YYYY-MM-DD')
				console.log('首次签署日期=======', firstSignTime)
				console.log('再次签署日期=======', this.endSignTime)
				if (this.whiteSignTime < this.endSignTime) window.localStorage.setItem('isSign', '1')
			}
		})
	}

	goShop() {
		// 从白条来跳转全部订单页面
		// let FDWhite = window.localStorage.getItem('FDWhite')
		// console.log('FDWhite-----', FDWhite)
		if (this.$route.query.fromPage === '认证通过') {
			this.$router.push({
				path: '/orderMall',
				query: {
					orderName: '全部订单',
					from: 'authorizeConfirm',
				},
			})
		} else {
			this.$router.back()
		}
	}

	goOrderFinan() {
		// if (!this.$action('orderFinance')) {
		// 	return false
		// }
		this.$router.push('/orderFinance')
	}
	entryChannel() {
		// if (!this.$action('entryChannel')) {
		// 	return false
		// }
		this.$bridge.callHandler('entryChannel')
	}
}
